import { toast, ToastOptions } from "react-toastify";
import { FaCheck, FaTimes, FaExclamation, FaInfo } from "react-icons/fa";
import { ReactNode } from "react";

type ToastType = "success" | "error" | "warning" | "info";

const icons: Record<ToastType, ReactNode> = {
  success: <FaCheck />,
  error: <FaTimes />,
  warning: <FaExclamation />,
  info: <FaInfo />,
};

const show = (
  type: ToastType,
  title: string,
  message?: string,
  options?: ToastOptions,
) => {
  toast(
    <div className={`premium-toast ${type}`}>
      <div className="toast-icon">{icons[type]}</div>

      <div className="toast-content">
        <h4>{title}</h4>
        {message && <p>{message}</p>}
      </div>
    </div>,
    {
      className: "toast-wrapper",
      icon: false,
      ...options,
    },
  );
};

export const Toast = {
  success: (title: string, message?: string, options?: ToastOptions) =>
    show("success", title, message, options),

  error: (title: string, message?: string, options?: ToastOptions) =>
    show("error", title, message, options),

  warning: (title: string, message?: string, options?: ToastOptions) =>
    show("warning", title, message, options),

  info: (title: string, message?: string, options?: ToastOptions) =>
    show("info", title, message, options),
};
